import React, { Component } from 'react';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import ReactJson from 'react-json-view';
import useAPIResReqStore from '../useAPIResReqStore';
import Grid from '@mui/material/Grid';
import HandleJsonFunction from '../../Component/HandleJsonFunction';
import AlertMessage from './AlertMessage';
import useThemeStore, { resolveMode } from '../../../stores/useThemeStore';

class ResponseReceived extends Component {
  constructor(props) {
    super(props);
  }

  handleJson = async () => {
    const { responseData, name } = useAPIResReqStore.getState();
    await HandleJsonFunction.handleAddPlaceholdersJson(responseData.json, useAPIResReqStore.getState());
    await this.props.onChangeState(2, 2);
  };

  handleReactJson = () => {
    const { responseData } = useAPIResReqStore.getState();
    const isDark = resolveMode(useThemeStore.getState().preference) === 'dark';
    if (responseData.json != '') {
      let jsonData = JSON.parse(responseData.json);
      const fg = isDark ? '255, 255, 255' : '1, 1, 1';
      const fg2 = isDark ? '255, 255, 255' : '0, 0, 0';

      return (
        <ReactJson
          src={jsonData ? jsonData : {}}
          collapsed="true"
          name="Data"
          displayDataTypes={false}
          style={{ fontFamily: 'Open Sans !important' }}
          theme={{
            base00: `rgba(${fg}, 0)`,
            base01: `rgba(${fg}, 0.1)`,
            base02: `rgba(${fg2}, 0.2)`,
            base03: `rgba(${fg}, 0.3)`,
            base04: `rgba(${fg2}, 0.4)`,
            base05: `rgba(${fg}, 0.5)`,
            base06: `rgba(${fg}, 0.6)`,
            base07: `rgba(${fg}, 0.7)`,
            base08: `rgba(${fg}, 0.8)`,
            base09: `rgba(${fg}, 0.8)`,
            base0A: `rgba(${fg}, 0.8)`,
            base0B: `rgba(${fg}, 0.8)`,
            base0C: `rgba(${fg}, 0.8)`,
            base0D: `rgba(${fg}, 0.8)`,
            base0E: `rgba(${fg}, 0.8)`,
            base0F: `rgba(${fg}, 0.8)`,
          }}
        />
      );
    }
  };

  render() {
    return (
      <Grid container className="textAlignLeft">
        <AlertMessage
          message={
            'A sample has been received. Continue to the next step or click Send Request to get another sample.'
          }
          alertType="success"
        />
        <br />
        <Grid item xs={12} className="json-webhook">
          {this.handleReactJson()}
        </Grid>
        <Grid item xs={12} className="dialogContentRight">
          <Grid item xs={12}>
            <Button onClick={this.handleJson} variant={'contained'} color={'primary'}>
              {' '}
              Next
            </Button>
          </Grid>
        </Grid>
      </Grid>
    );
  }
}

export default ResponseReceived;
